export const TERMS_AND_CONDITIONS_PAGE = "/terminos-condiciones";
export const PRIVACY_POLICY_PAGE = "/politica-privacidad";
export const PRIVACY_POLICY_SUMMARY_PAGE = "/politica-privacidad-resumida";
export const COOKIES_POLICY_PAGE = "/cookies-politicas";